export default __webpack_public_path__ + "media/images/logo-symbol-wordmark-3d4965d2a3d8971e694501d8bcda5b8d.svg";